app.controller("ExamsManagerEditHallController", [
    "$scope", "ExamsManagerService", "$uibModalInstance", "$state", "$uibModal", "toastr", "params",
    function ($scope, ExamsManagerService, $uibModalInstance, $state, $uibModal, toastr, params) {
        console.log(params);

        $scope.examHallId = params.examHall._id;
        $scope.name = params.examHall.name;
        $scope.count = params.examHall.seatCount;
        $scope.ordered = params.examHall.ordered;
        $scope.withComputers = params.examHall.withComputers;

        $scope.edit = function () {
            ExamsManagerService.editExamHall({
                examHallId: $scope.examHallId,
                name: $scope.name,
                seatCount: $scope.count,
                ordered: $scope.ordered,
                withComputers: $scope.withComputers
            }).then(function () {
                toastr.success('', 'ოთახი რედაქტირებულია');
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);